/**
 * "Hand to Cursor" — copies a ready-to-paste prompt to the clipboard so a task
 * can be dropped straight into a coding agent. Later this can deep-link into
 * Cursor's background agents or open a PR via the API.
 */
export async function handToCursor(title: string): Promise<void> {
  const prompt = `Task: ${title}\n\nContext: Mithril Media client work. Please implement and open a PR.`;
  try {
    await navigator.clipboard?.writeText(prompt);
  } catch {
    // Clipboard may be unavailable (e.g. insecure context); ignore.
  }
}
